<div class="min-h-screen bg-white">
  <header class="px-6 pt-14 pb-11 flex justify-center w-full">
    <img src="/assets/imgs/afp-capital.png" alt="AFP Capital" class="max-w-44 max-h-[58px]" />
  </header>

  <main class="mx-auto flex flex-col items-center">
    <div class="text-center w-full flex flex-col mb-11">
      <h2 class="text-2xl md:text-4xl font-bold text-blue-dark mb-6 px-4 lg:w-[40%] lg:mx-auto">
        {{ customerName() }}, revisa el video de tu Informe de Pensiones Personalizado
      </h2>
      <p class="text-base md:text-xl text-navy max-w-[680px] mx-auto px-4">
        Recuerda que el detalle de tus saldos, las variables que impactan en tu pensión y nuestra
        asesoría está en tu Informe de Pensiones en PDF
      </p>
      <button
        type="button"
        (click)="onDownloadClick()"
        [disabled]="isDownloading()"
        class="bg-navy flex items-center justify-center gap-4 w-4/5 self-center md:w-[316px] px-6 py-3 rounded-full text-white font-medium shadow-lg hover:opacity-90 transition-opacity mt-7 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        @if (isDownloading()) {
          <span class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          <span class="text-lg">Descargando...</span>
        } @else {
          <img src="/assets/icons/download-icon.svg" alt="Download Icon" class="w-4 h-4" />
          <span class="text-lg">Descarga tu Informe en PDF</span>
        }
      </button>
    </div>

    <div
      class="w-full flex flex-col justify-center bg-[url('/assets/backgrounds/landing-background.svg')] bg-cover bg-top bg-no-repeat pb-8"
    >
      <div class="mb-14 w-full max-w-4xl px-4 self-center">
        <div id="individeo-container" class="rounded-xl aspect-video relative overflow-hidden">
          @if (!videoReady()) {
            <div class="w-full h-full flex items-center justify-center bg-gradient-primary">
              <div class="flex flex-col items-center">
                <div
                  class="md:w-20 md:h-20 w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-lg animate-pulse"
                >
                  <img src="/assets/icons/play-icon.svg" alt="Play Icon" />
                </div>
                <p class="text-white md:text-lg font-medium">Cargando tu video personalizado...</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </main>

  <section class="text-white py-16 relative bg-gradient-primary-horizontal">
    <div class="max-w-7xl mx-auto px-6">
      <div class="text-center mb-12">
        <h3 class="text-xl font-bold mb-4">Un servicio exclusivo de AFP Capital</h3>
        <p class="text-blue-200 max-w-[590px] mx-auto text-base font-[450]">
          Tu Informe de Inversiones Personalizado contiene información exclusiva para ti, de manera
          segura y confiable. Asesorándote en línea con tus objetivos.
        </p>
      </div>

      <div class="flex flex-col gap-6 mb-8 justify-center items-center md:flex-row">
        <app-info-card
          icon="wallet-icon.svg"
          title="Pensión estimada"
          description="Conoce tu pensión proyectada según tu ahorro actual y cómo mejorarla."
          [index]="0"
          [isExpanded]="isCardExpanded(0)"
          (toggleCard)="toggleCard($event)"
        />

        <app-info-card
          icon="chart-icon.svg"
          title="Evolución de saldos"
          description="Visualiza cómo ha crecido tu ahorro previsional a lo largo del tiempo."
          [index]="1"
          [isExpanded]="isCardExpanded(1)"
          (toggleCard)="toggleCard($event)"
        />

        <app-info-card
          icon="dashboard-icon.svg"
          title="Rentabilidad histórica"
          description="Analiza el rendimiento de tus inversiones y compara fondos."
          [index]="2"
          [isExpanded]="isCardExpanded(2)"
          (toggleCard)="toggleCard($event)"
        />
      </div>

      @if (showFeedbackWidget()) {
        <div
          class="fixed bottom-6 right-0 bg-gradient-primary rounded-tl-xl rounded-bl-xl p-2 shadow-xl z-50 max-h-[73px] max-w-[190px] border-6 border-l-white border-t-white border-b-white border-r-0"
        >
          <div class="flex items-center justify-between h-full">
            <a
              [href]="surveyUrl()"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white font-semibold text-base hover:underline"
            >¿Qué opinas de este servicio?</a>
            <button
              (click)="closeFeedbackWidget()"
              class="text-white rounded-md bg-navy flex items-center justify-center w-7 h-7"
              aria-label="Cerrar widget de feedback"
            >
              <mat-icon class="text-white">close</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </section>

  <footer class="py-9">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-2 flex-1">
          <img
            src="/assets/imgs/sp-logo.png"
            alt="SUPERINTENDENCIA DE PENSIONES"
            class="w-[66px] h-[30px]"
          />
          <p class="text-sm w-3/4">
            Entrega tu opinión a la SUPERINTENDENCIA DE PENSIONES sobre la calidad de servicio de tu
            AFP,
            <a href="#" class="text-blue-700 hover:underline">comienza aquí</a>
          </p>
        </div>
        <div
          class="flex flex-wrap gap-4 text-sm flex-1 flex-col md:flex-row justify-center items-center md:justify-start md:items-start"
        >
          <a href="#" class="text-blue-600 hover:underline font-light">Términos y condiciones</a>
          <a href="#" class="text-blue-600 hover:underline font-light"
            >Políticas de privacidad y seguridad</a
          >
          <a href="#" class="text-blue-600 hover:underline font-light">Protégete del phishing</a>
        </div>
      </div>
    </div>
  </footer>
</div>
